const CircleIcon = ({ dark }: { dark?: boolean }) => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 35 35"
    width="35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17.5"
      cy="17.5"
      fill={dark ? 'rgba(255,255,255,0.2)' : '#F3F3F0'}
      r={dark ? '17.5' : '16.75'}
      stroke={dark ? undefined : '#B1B1B1'}
      strokeWidth={dark ? undefined : '1.5'}
    />
    <circle
      cx="17.5"
      cy="17.4998"
      fill={dark ? 'rgba(255,255,255,0.4)' : '#B1B1B1'}
      r="10.2083"
    />
  </svg>
)
export default CircleIcon
